'use client';

import type { ProgramRelated } from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import { Slider } from '@eqi-investimentos/slider';
import { useT } from '@/libs/i18n/utils/useT';
import { ContentProgressCard } from '@/modules/Entertainment/ui/Widgets/ContentProgressCard';
import '@eqi-investimentos/slider/css';

export const ProgramRelatedContent: FC<ResearchContentsProps> = ({ data }) => {
  const t = useT();

  if (data.length === 0) {
    return <></>;
  }

  return (
    <Flex
      id="relacionados"
      flexDir="column"
      gap="l"
      sx={{
        '& > div > div': {
          _first: {
            right: '2xl',
            position: 'absolute',
            top: '-3.25rem',
          },
          mr: 'negative.2xl',
          minH: 0,
        },
        '& .swiper-slide': {
          width: 'fit-content',
          _last: { pr: '2xl' },
        },
      }}
    >
      <Text size="2xl">{t('screens.researchProgram.related.title')}</Text>
      <Slider
        id="related-content-slider"
        displayProgress={false}
        controlsAlignment="top-right"
        swiperGap="0px"
      >
        {data.map(
          ({
            program_title,
            program_type_trans,
            published_at,
            slug,
            thumb,
            title,
          }) => (
            <ContentProgressCard
              key={title}
              title={program_title}
              subtitle={title}
              description={`${published_at} • ${program_type_trans}`}
              hideProgress
              slug={slug}
              thumbAlt={title}
              thumbUrl={thumb}
              containerProps={{ w: '21.75rem' }}
            />
          )
        )}
      </Slider>
    </Flex>
  );
};

export type ResearchContentsProps = {
  data: ProgramRelated[];
};
